/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1StringList } from '../models/V1StringList';
import { HttpFile } from '../http/http';

export class V1TemplateVariableValue {
    'singleValue'?: string;
    'listValue'?: V1StringList;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "singleValue",
            "baseName": "single_value",
            "type": "string",
            "format": ""
        },
        {
            "name": "listValue",
            "baseName": "list_value",
            "type": "V1StringList",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1TemplateVariableValue.attributeTypeMap;
    }

    public constructor() {
    }
}

